module.exports = __webpack_public_path__ + "static/img/ability-down.90f180fe.png";